module.exports = __webpack_public_path__ + "ed1036f27ddb3a3097b1b158fd21542c.svg";


//////////////////
// WEBPACK FOOTER
// ./images/devfest-logo.svg
// module id = f3EW
// module chunks = 4